module.exports = __webpack_public_path__ + "img/icon-website green.f12e69dd.svg";